/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/job.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiPipelineSpec } from './ApiPipelineSpec';
import {
  ApiPipelineSpecFromJSON,
  ApiPipelineSpecFromJSONTyped,
  ApiPipelineSpecToJSON,
  ApiPipelineSpecToJSONTyped,
} from './ApiPipelineSpec';
import type { JobMode } from './JobMode';
import {
  JobModeFromJSON,
  JobModeFromJSONTyped,
  JobModeToJSON,
  JobModeToJSONTyped,
} from './JobMode';
import type { ApiTrigger } from './ApiTrigger';
import {
  ApiTriggerFromJSON,
  ApiTriggerFromJSONTyped,
  ApiTriggerToJSON,
  ApiTriggerToJSONTyped,
} from './ApiTrigger';
import type { ApiResourceReference } from './ApiResourceReference';
import {
  ApiResourceReferenceFromJSON,
  ApiResourceReferenceFromJSONTyped,
  ApiResourceReferenceToJSON,
  ApiResourceReferenceToJSONTyped,
} from './ApiResourceReference';

/**
 *
 * @export
 * @interface ApiJob
 */
export interface ApiJob {
  /**
   * Output. Unique run ID. Generated by API server.
   * @type {string}
   * @memberof ApiJob
   */
  id?: string;
  /**
   * Required input field. Job name provided by user. Not unique.
   * @type {string}
   * @memberof ApiJob
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiJob
   */
  description?: string;
  /**
   *
   * @type {ApiPipelineSpec}
   * @memberof ApiJob
   */
  pipeline_spec?: ApiPipelineSpec;
  /**
   * Optional input field. Specify which resource this job belongs to.
   * @type {Array<ApiResourceReference>}
   * @memberof ApiJob
   */
  resource_references?: Array<ApiResourceReference>;
  /**
   * Optional input field. Specify which Kubernetes service account this job uses.
   * @type {string}
   * @memberof ApiJob
   */
  service_account?: string;
  /**
   *
   * @type {string}
   * @memberof ApiJob
   */
  max_concurrency?: string;
  /**
   *
   * @type {ApiTrigger}
   * @memberof ApiJob
   */
  trigger?: ApiTrigger;
  /**
   *
   * @type {JobMode}
   * @memberof ApiJob
   */
  mode?: JobMode;
  /**
   * Output. The time this job is created.
   * @type {Date}
   * @memberof ApiJob
   */
  created_at?: Date;
  /**
   * Output. The last time this job is updated.
   * @type {Date}
   * @memberof ApiJob
   */
  updated_at?: Date;
  /**
   *
   * @type {string}
   * @memberof ApiJob
   */
  status?: string;
  /**
   * In case any error happens retrieving a job field, only job ID
   * and the error message is returned. Client has the flexibility of choosing
   * how to handle error. This is especially useful during listing call.
   * @type {string}
   * @memberof ApiJob
   */
  error?: string;
  /**
   * Input. Whether the job is enabled or not.
   * @type {boolean}
   * @memberof ApiJob
   */
  enabled?: boolean;
  /**
   * Optional input field. Whether the job should catch up if behind schedule.
   * If true, the job will only schedule the latest interval if behind schedule.
   * If false, the job will catch up on each past interval.
   * @type {boolean}
   * @memberof ApiJob
   */
  no_catchup?: boolean;
}

/**
 * Check if a given object implements the ApiJob interface.
 */
export function instanceOfApiJob(value: object): value is ApiJob {
  return true;
}

export function ApiJobFromJSON(json: any): ApiJob {
  return ApiJobFromJSONTyped(json, false);
}

export function ApiJobFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiJob {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    description: json['description'] == null ? undefined : json['description'],
    pipeline_spec:
      json['pipeline_spec'] == null ? undefined : ApiPipelineSpecFromJSON(json['pipeline_spec']),
    resource_references:
      json['resource_references'] == null
        ? undefined
        : (json['resource_references'] as Array<any>).map(ApiResourceReferenceFromJSON),
    service_account: json['service_account'] == null ? undefined : json['service_account'],
    max_concurrency: json['max_concurrency'] == null ? undefined : json['max_concurrency'],
    trigger: json['trigger'] == null ? undefined : ApiTriggerFromJSON(json['trigger']),
    mode: json['mode'] == null ? undefined : JobModeFromJSON(json['mode']),
    created_at: json['created_at'] == null ? undefined : new Date(json['created_at']),
    updated_at: json['updated_at'] == null ? undefined : new Date(json['updated_at']),
    status: json['status'] == null ? undefined : json['status'],
    error: json['error'] == null ? undefined : json['error'],
    enabled: json['enabled'] == null ? undefined : json['enabled'],
    no_catchup: json['no_catchup'] == null ? undefined : json['no_catchup'],
  };
}

export function ApiJobToJSON(json: any): ApiJob {
  return ApiJobToJSONTyped(json, false);
}

export function ApiJobToJSONTyped(
  value?: ApiJob | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    name: value['name'],
    description: value['description'],
    pipeline_spec: ApiPipelineSpecToJSON(value['pipeline_spec']),
    resource_references:
      value['resource_references'] == null
        ? undefined
        : (value['resource_references'] as Array<any>).map(ApiResourceReferenceToJSON),
    service_account: value['service_account'],
    max_concurrency: value['max_concurrency'],
    trigger: ApiTriggerToJSON(value['trigger']),
    mode: JobModeToJSON(value['mode']),
    created_at:
      value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
    updated_at:
      value['updated_at'] == null ? value['updated_at'] : value['updated_at'].toISOString(),
    status: value['status'],
    error: value['error'],
    enabled: value['enabled'],
    no_catchup: value['no_catchup'],
  };
}
